import { setupFormState } from '@/components/form/tidal-form'
import { NotificationFormValues } from './types'

export const form = setupFormState<NotificationFormValues>({
  id: 'notificationForm',
  initialValues: {
    id: '',
    includeMessageUnsubscriptionInstructions: false,
    windowOfCommitmentToleranceMins: '30',
    windowOfCommitmentSnapToMins: 0,
    includeMessageTrackingLink: false,
    alwaysNotifyAfterCutoff: false,
    notificationCutoffMins: 0,
    proximityThresholdMins: '10',
    templateDefaultLimits: {},
    templateCustomLimits: {},
    backupSubjectCustom: '',
    backupNotification: false,
    notificationWay: 'EMAIL',
    templatePreview: '',
    templateDefault: '',
    subjectDefault: '',
    templateCustom: '',
    toleranceMins: 'No',
    subjectCustom: '',
    enabled: true,
  },
})
